import { AceEditorTheme } from 'modules/aceEditor';
import { HtmlEditor } from 'modules/graphql';
import { displayContent } from 'modules/templateEditor/common';

export const SIDE_BY_SIDE_EDITOR_THEME_MAPPER = {
  [AceEditorTheme.Chrome]: displayContent.labelThemeChrome,
  [AceEditorTheme.Clouds]: displayContent.labelThemeClouds,
  [AceEditorTheme.Github]: displayContent.labelThemeGithub,
  [AceEditorTheme.Monokai]: displayContent.labelThemeMonokai,
  [AceEditorTheme.Twilight]: displayContent.labelThemeTwilight,
} as const;

export const CONTENT_EDITOR_LABEL_MAPPER = {
  [HtmlEditor.Ace]: displayContent.labelSideBySide,
  [HtmlEditor.Bee]: displayContent.labelDragDrop,
  [HtmlEditor.Wysiwyg]: displayContent.labelWysiwyg,
} as const;
